module.exports = __webpack_public_path__ + "media/old_images/intro-android-default-aba1f469.png";